import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Shield, Loader2, Lock, User } from "lucide-react";

// Admin credentials - In production, this should be validated server-side
const ADMIN_CREDENTIALS = {
  username: "tajadmin",
  password: "TajCement@2024"
};

export default function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Simulate a brief delay for security
    await new Promise(resolve => setTimeout(resolve, 500));

    if (username === ADMIN_CREDENTIALS.username && password === ADMIN_CREDENTIALS.password) {
      // Store session in localStorage
      const session = {
        authenticated: true,
        username: username,
        loginTime: new Date().toISOString(),
        expiresAt: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString() // 24 hours
      };
      localStorage.setItem("adminSession", JSON.stringify(session));
      toast.success("Login successful!");
      onLogin(true);
    } else {
      toast.error("Invalid username or password");
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md rounded-sm">
        <CardHeader className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
            <Shield className="w-8 h-8 text-primary" />
          </div>
          <CardTitle className="text-2xl" style={{ fontFamily: 'Manrope' }}>Admin Login</CardTitle>
          <CardDescription>Enter your credentials to access the admin dashboard</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="username">Username</Label>
              <div className="relative">
                <User className="w-4 h-4 absolute left-3 top-3 text-muted-foreground" />
                <Input
                  id="username"
                  type="text"
                  placeholder="Enter username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="pl-10 rounded-none"
                  required
                  data-testid="admin-username-input"
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <div className="relative">
                <Lock className="w-4 h-4 absolute left-3 top-3 text-muted-foreground" />
                <Input
                  id="password"
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="pl-10 rounded-none"
                  required
                  data-testid="admin-password-input"
                />
              </div>
            </div>
            <Button 
              type="submit" 
              className="w-full h-12 rounded-none uppercase tracking-wider"
              disabled={loading}
              data-testid="admin-login-btn"
            >
              {loading ? (
                <Loader2 className="w-5 h-5 animate-spin mr-2" />
              ) : (
                <Lock className="w-5 h-5 mr-2" />
              )}
              Login to Admin
            </Button>
          </form>
          
          <div className="mt-6 pt-4 border-t">
            <p className="text-xs text-center text-muted-foreground">
              Taj Cement Channel Loyalty - Admin Portal
            </p>
          </div>
        </CardContent>
      </Card>
      
      {/* Footer */}
      <div className="fixed bottom-4 left-0 right-0 flex items-center justify-center gap-2">
        <span className="text-sm text-muted-foreground">Powered by</span>
        <img 
          src={require("@/assets/tagnpay-logo.png")} 
          alt="Tag'N'Pay" 
          className="h-6 w-auto"
        />
      </div>
    </div>
  );
}
